import React, {Component} from 'react';
import CommessaSelect3List from './CommessaSelect3List'
import PropTypes from 'prop-types';
class CommessaSelect3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commessa: undefined
        };
        this.onChange = this.onChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        // if (nextProps.commessa !== undefined ){
        //     this.setState({commessa: nextProps.commessa})
        // }

        this.setState({commessa: nextProps.commessa})
    }

    onChange(commessa) {
        this.props.onChange(commessa);
        this.setState({commessa: commessa})
    }

    render() {

        return (<div className="ui cards">
                <CommessaSelect3List
                    onChange={this.onChange}
                    height="1200px"
                    fluid={this.props.fluid}
                    compact={this.props.compact}
                    commesseList={this.props.commesseList}
                    title="Scegli la Commessa di lavoro..."
                    commessa={this.state.commessa}
                />
            </div>
        )
    }
}

CommessaSelect3.PropTypes = {
    onChange: PropTypes.func.isRequired,
    fluid: PropTypes.bool.isRequired,
    compact: PropTypes.bool.isRequired,
    commessa: PropTypes.object.isRequired,
    commesseList: PropTypes.array.isRequired
}

CommessaSelect3.defaultProps = {
    fluid: false,
    compact: false,
    commessa: undefined,
};
export default CommessaSelect3;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommessaSelect3.js
 **/